'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _objectDestructuringEmpty2 = require('babel-runtime/helpers/objectDestructuringEmpty');

var _objectDestructuringEmpty3 = _interopRequireDefault(_objectDestructuringEmpty2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.isLoaded = isLoaded;
exports.load = load;
exports.login = login;
exports.logout = logout;
exports.redirect = redirect;
exports.loginFromToken = loginFromToken;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LOAD = 'redux-example/auth/LOAD';
var LOAD_SUCCESS = 'redux-example/auth/LOAD_SUCCESS';
var LOAD_FAIL = 'redux-example/auth/LOAD_FAIL';
var LOGIN = 'redux-example/auth/LOGIN';
var LOGIN_SUCCESS = 'redux-example/auth/LOGIN_SUCCESS';
var LOGIN_FAIL = 'redux-example/auth/LOGIN_FAIL';
var LOGOUT = 'redux-example/auth/LOGOUT';
var LOGOUT_SUCCESS = 'redux-example/auth/LOGOUT_SUCCESS';
var LOGOUT_FAIL = 'redux-example/auth/LOGOUT_FAIL';

var VERIFY_LOGIN = 'redux-example/auth/VERIVY_LOGIN';
var VERIFY_LOGIN_SUCCESS = 'redux-example/auth/VERIVY_LOGIN_SUCCESS';
var VERIFY_LOGIN_FAIL = 'redux-example/auth/VERIVY_LOGIN_FAIL';

var REDIRECT_SUCCESS = 'app/auth/REDIRECT_SUCCESS';

var initialState = {
  loaded: false
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case LOAD:
      return (0, _extends3.default)({}, state, {
        loading: true
      });
    case LOAD_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: true,
        user: action.result
      });
    case LOAD_FAIL:
      return (0, _extends3.default)({}, state, {
        loading: false,
        loaded: false,
        error: action.error
      });
    case LOGIN:
      return (0, _extends3.default)({}, state, {
        loggingIn: true
      });
    case LOGIN_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: action.result
      });
    case LOGIN_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingIn: false,
        user: null,
        loginError: action.error
      });
    case LOGOUT:
      return (0, _extends3.default)({}, state, {
        loggingOut: true
      });
    case LOGOUT_SUCCESS:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        user: null
      });
    case LOGOUT_FAIL:
      return (0, _extends3.default)({}, state, {
        loggingOut: false,
        logoutError: action.error
      });
    case REDIRECT_SUCCESS:
      //redirect here
      window.location.replace(action.result);
      return (0, _extends3.default)({}, state, {
        redirectPath: action.result
      });
    default:
      return state;
  }
}

function verifyFromToken(userId, accessToken) {
  return {
    types: [VERIFY_LOGIN, VERIFY_LOGIN_SUCCESS, VERIFY_LOGIN_FAIL],
    promise: function promise(_ref) {
      var oneApiClient = _ref.oneApiClient;
      return oneApiClient.get('/users/loadAuth', {
        params: {
          userId: userId,
          accessToken: accessToken
        }
      });
    } //
  };
}

/*
* Actions
* * * * */
function isLoaded(globalState) {
  return globalState.auth && globalState.auth.loaded;
}

function load() {
  return {
    types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
    promise: function promise(_ref2) {
      var client = _ref2.client;
      return client.get('/loadAuth');
    }
  };
}

function login(name) {
  return {
    types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
    promise: function promise(_ref3) {
      var client = _ref3.client;
      return client.post('/login', {
        data: {
          name: name
        }
      });
    }
  };
}

function logout() {
  return {
    types: [LOGOUT, LOGOUT_SUCCESS, LOGOUT_FAIL],
    promise: function promise(_ref4) {
      var client = _ref4.client;
      return client.get('/logout');
    }
  };
}

function redirect(path) {
  console.log("path:");
  console.log(path);
  return {
    types: ["REDIRECT", REDIRECT_SUCCESS, "REDIRECT_FAIL"],
    promise: function promise(_ref5) {
      var client = _ref5.client;
      return client.get('/redirect', {
        params: {
          path: path
        }
      });
    }
  };
}

function loginFromToken(userId, accessToken) {
  var _this = this;

  console.log('loginFromToken');
  return function (dispatch) {
    return dispatch(verifyFromToken(userId, accessToken)).then(function (data) {
      return dispatch({
        types: [LOGIN, LOGIN_SUCCESS, LOGIN_FAIL],
        promise: function () {
          var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref7) {
            var response;
            return _regenerator2.default.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    (0, _objectDestructuringEmpty3.default)(_ref7);
                    _context.prev = 1;
                    response = data.accessToken;

                    response.user = data;
                    console.log(response);

                    return _context.abrupt('return', data);

                  case 8:
                    _context.prev = 8;
                    _context.t0 = _context['catch'](1);

                    console.log(_context.t0);
                    // if (strategy === 'local') {
                    //   return catchValidation(error);
                    // }
                    throw _context.t0;

                  case 12:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _callee, _this, [[1, 8]]);
          }));

          return function promise(_x3) {
            return _ref6.apply(this, arguments);
          };
        }()
      });
    }).then(function (data) {
      // save into Session
      console.log('save the data');
      console.log(data);
      // console.log(JSON.parse(data));
      return dispatch({
        types: ['LOGIN_SAVE', 'LOGIN_SAVE_SUCCESS', 'LOGIN_SAVE_FAIL'],
        promise: function promise(_ref8) {
          var client = _ref8.client;
          return client.post('/login', {
            data: {
              email: data.email,
              _id: data.id,
              accessToken: {
                id: data.accessToken.id
              }
            }
          });
        }
      });
    }).catch(function (error) {
      console.log(error);
      // if (strategy === 'local') {
      //   return catchValidation(error);
      // }
      throw error;
    });
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/auth.js
// module id = 139
// module chunks = 0